// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22T4x","controls":"styles_controls__354cX","charLimit":"styles_charLimit__3Qjwm","input":"styles_input__kDvNe","send":"styles_send__odvv8"};